export const sources={};export const img={src:"__VITE_ASSET__D8_i6G3V__",w:36,h:36};export default{sources:sources,img:img};